/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('theme:slider:ready', (event) => {
    if (typeof Flickity === 'undefined') return;
    const sliderElement = event.detail.slider;
    const flkty = Flickity.data(sliderElement);

    if (flkty) {
      flkty.options.draggable = true;
      flkty.options.accessibility = true;
      flkty.updateDraggable(); // Update draggable behavior
      flkty.resize(); // Recalculate cell sizes and positions
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
